module.exports = __webpack_public_path__ + "img/no_image.67e35e96.svg";